export default "__VITE_ASSET__uwYkHS$B__"